import { gsap } from 'gsap';

import { gameMainDrawer } from '../game/drawers/gameMainDrawer';
import {
  SPIN_BUTTON_SCALE_IN_X_AND_Y,
  SPIN_BUTTON_ROTATION_IN_LOOP,
  SPIN_BUTTON_SCALE_OUT_X_AND_Y,
  SPIN_BUTTON_SCALE_REPEAT_COUNT,
  WEB_BET_CONTAINER_START_POSITION_X,
  MOBILE_BET_CONTAINER_START_POSITION_X,
  SPIN_BUTTON_ARROWS_LOOP_ANIMATION_DURATION,
} from '../constants';
import { isMobile } from '../helpers/isMobile';
import { spinBarStore } from '../store/spinBarStore';
import { gambleStore } from '../store/gambleStore';

class AnimationService {
  spinButtonRotateAndReturnAnimation(sprite) {
    return new Promise((resolve) => {
      gsap.to(sprite, {
        rotation: SPIN_BUTTON_ROTATION_IN_LOOP,
        duration: SPIN_BUTTON_ARROWS_LOOP_ANIMATION_DURATION,
        ease: 'none',
        onComplete: () => {
          gsap.to(sprite, {
            rotation: 0,
            duration: SPIN_BUTTON_ARROWS_LOOP_ANIMATION_DURATION,
            ease: 'none',
          });
        },
      });
      resolve(true);
    });
  }

  spinButtonScaleAndReturnAnimation(sprite) {
    return new Promise((resolve) => {
      gsap.to(sprite.scale, {
        x: SPIN_BUTTON_SCALE_IN_X_AND_Y,
        y: SPIN_BUTTON_SCALE_IN_X_AND_Y,
        repeat: SPIN_BUTTON_SCALE_REPEAT_COUNT,
        duration: SPIN_BUTTON_ARROWS_LOOP_ANIMATION_DURATION,
        yoyo: true,
        onComplete: () => {
          gsap.to(sprite.scale, {
            x: SPIN_BUTTON_SCALE_OUT_X_AND_Y,
            y: SPIN_BUTTON_SCALE_OUT_X_AND_Y,
            duration: SPIN_BUTTON_ARROWS_LOOP_ANIMATION_DURATION,
          });
        },
      });
      resolve(true);
    });
  }

  animateWithGsap({ container, x, onComplete, duration, ease = 'none' }) {
    gsap.to(container, {
      ease,
      duration,
      x,
      onComplete,
    });
  }

  slideAnimation({ container, isLeft = false, onComplete }) {
    let leftMoveBetButtonsX = isMobile()
      ? container.x + 4 * gameMainDrawer.betBar.betAmountButtonsWidthWithMargin
      : container.x + 4 * gameMainDrawer.betBar.betAmountButtonsWidthWithMargin;

    let rightMoveBetButtonsX = isMobile()
      ? container.x - 4 * gameMainDrawer.betBar.betAmountButtonsWidthWithMargin
      : container.x - 4 * gameMainDrawer.betBar.betAmountButtonsWidthWithMargin;
    const startXPosition = isMobile()
      ? MOBILE_BET_CONTAINER_START_POSITION_X
      : WEB_BET_CONTAINER_START_POSITION_X;

    const endXPosition = isMobile()
      ? gameMainDrawer.betBar.mobileBetContainerEndPositionX
      : gameMainDrawer.betBar.webBetContainerEndPositionX;

    leftMoveBetButtonsX =
      leftMoveBetButtonsX > startXPosition ? startXPosition : leftMoveBetButtonsX;
    rightMoveBetButtonsX =
      rightMoveBetButtonsX < endXPosition ? endXPosition : rightMoveBetButtonsX;

    this.animateWithGsap({
      container,
      x: isLeft ? leftMoveBetButtonsX : rightMoveBetButtonsX,
      onComplete,
      duration: 0.4,
    });
  }

  spinButtonAnimationOnSpinAction(element) {
    return new Promise((resolve) => {
      gsap.to(element, {
        rotation: 2 * Math.PI,
        duration:
          spinBarStore.gameReelSpeedMode.standard && !spinBarStore.isDoubleClick ? 0.6 : 0.2,
        ease: 'none',
        onComplete: () => {
          gsap.to(element, {
            rotation: 0,
            duration: 0,
            ease: 'none',
          });
          resolve();
        },
      });
    });
  }

  handleHistoryCardAnimation({ fn, card, count, isGambleWin, isLast, gambleFinished }) {
    if (card.id) {
      if (card.id === count) {
        gsap.to(card, {
          x: card.width + (isMobile() ? 2 : 4),
          duration: 0.6,
          ease: 'none',
          onComplete: () => {
            if ((!isGambleWin && isLast) || gambleFinished) {
              fn();
            }
          },
        });
      } else {
        gsap.to(card, {
          x: card.x + card.width + (isMobile() ? 2 : 4),
          duration: 0.6,
          ease: 'none',
          onComplete: () => {
            if ((!isGambleWin && isLast) || gambleFinished) {
              fn();
            }
          },
        });
      }
    }
  }

  handleHistoryContainerAnimation({ container }) {
    gsap.to(container, {
      x: -container.width / 2,
      duration: 0.6,
      ease: 'none',
    });
  }

  handleGambleStartButtonPulseAnimation(sprite) {
    const pulseTimeline = gsap.timeline({ repeat: -1 });
    pulseTimeline.to(sprite.scale, {
      x: 1,
      y: 1,
      yoyo: true,
      duration: 0.5,
      repeat: -1,
    });
    pulseTimeline.to(sprite.scale, {
      x: 1.3,
      y: 1.3,
      yoyo: true,
      duration: 0.5,
      repeat: -1,
    });
    this.pulseTimeline = pulseTimeline;
  }
}

export const animationService = new AnimationService();
